// extracted by mini-css-extract-plugin
module.exports = {"popUpBody__description":"DeleteDecisionStrategyModule_popUpBody__description__3O_jF","popUpBody__button":"DeleteDecisionStrategyModule_popUpBody__button__2nfKf"};